import _memoize from 'lodash.memoize';
import React, { Component } from 'react';
import Switch from '../../Switch';
import Text from '../../Text';
import '../styles/_toggleFilters.scss';
import FiltersGroupContainer from './FiltersGroupContainer';



















export default class ToggleFiltersGroup extends Component {
  handleFilterChange = _memoize((value) => () => {
    const { onChange } = this.props;
    return onChange(value);
  });

  render() {
    const {
      filterFacets,
      label: groupLabel,
      isCollapsible,
      openedByDefault,
      minWidth
    } = this.props;

    return (
      <FiltersGroupContainer
        label={groupLabel}
        isCollapsible={isCollapsible}
        openedByDefault={openedByDefault}
        minWidth={minWidth}>

        {filterFacets.map(({ subtitle, label, value }, index) =>
        <>
            <div className="toggle-filters">
              <Text heading4>{label}</Text>
              <Switch
              id={`switch-${index}`}
              checked={value}
              onChange={this.handleFilterChange(value)} />

            </div>
            <Text className="toggle-filters__subtitle" subtitle>
              {subtitle}
            </Text>
          </>
        )}
      </FiltersGroupContainer>);

  }
}